import { render, staticRenderFns } from "./AddUnion.vue?vue&type=template&id=ae90d366&scoped=true"
import script from "./AddUnion.vue?vue&type=script&lang=js"
export * from "./AddUnion.vue?vue&type=script&lang=js"
import style0 from "./AddUnion.vue?vue&type=style&index=0&id=ae90d366&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae90d366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae90d366')) {
      api.createRecord('ae90d366', component.options)
    } else {
      api.reload('ae90d366', component.options)
    }
    module.hot.accept("./AddUnion.vue?vue&type=template&id=ae90d366&scoped=true", function () {
      api.rerender('ae90d366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/add/AddUnion.vue"
export default component.exports